import { useCallback } from 'react';
import { Box, Divider } from '@material-ui/core';
import { QuoteShareLink } from '@setvi/shared/interfaces';
import { ReviewLinkMenu } from '../menu';
import SText from '../../../../sui/stext';
import { LinkContainer } from './LinkItem';

interface QuoteLinkItemProps {
  quoteLink: QuoteShareLink;
  onEdit: () => void;
  onDelete: () => void;
}

/**
 * The quote share link's row in the Review Links list, beside the resource
 * links. It reads the same as theirs, minus the resource count a quote share
 * has no equivalent for (DEV-785).
 */
export const QuoteLinkItem = ({
  quoteLink,
  onEdit,
  onDelete
}: QuoteLinkItemProps) => {
  const openPreview = useCallback(
    () => window.open(quoteLink?.href, '_blank')?.focus(),
    [quoteLink?.href]
  );

  return (
    <>
      <LinkContainer onClick={onEdit}>
        <Box>
          <Box display="flex">
            <SText
              variant="body1"
              showTooltip
              weight="bold"
              title={quoteLink?.name}
              maxLines={2}
            />
          </Box>
          <SText variant="body2" color="textSecondary">
            Quote link
          </SText>
        </Box>
        <Box onClick={e => e.stopPropagation()}>
          <ReviewLinkMenu
            onPreview={openPreview}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </Box>
      </LinkContainer>
      <Divider />
    </>
  );
};
